module.exports = __webpack_public_path__ + "static/media/iconRightWhite.ad75be97.svg";